import { Box, CircularProgress } from "@mui/material";
const RouteLoadingFallback = () => {
    return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
        </Box>
    );
};

export default RouteLoadingFallback;
